import { IPhotosStore } from './index'

export default {
  loading: true,
  photos: [],
} as IPhotosStore
